import { Link } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import { useModeDetection } from "../hooks/useModeDetection";

interface RouteErrorBoundaryProps {
  children: React.ReactNode;
}

/**
 * Error boundary specifically for route-level errors
 * Provides navigation options when a route fails
 */
function RouteErrorBoundary({ children }: RouteErrorBoundaryProps) {
  const { getRoute } = useModeDetection();

  const homeRoute = getRoute("/home");
  const quizRoute = getRoute("/quiz");

  const fallback = (
    <div className="fullscreen-center bg-surface-default text-text-primary p-4">
      <div className="text-center max-w-md">
        <div className="text-6xl mb-4">🗺️</div>
        <h1 className="text-2xl font-bold font-title mb-4">Page Not Found</h1>
        <p className="text-lg mb-6">
          The page you're looking for seems to have wandered off. Let's get you back on track!
        </p>

        <div className="space-y-4">
          <Link
            to={homeRoute}
            className="inline-block bg-brand-primary hover:bg-brand-primary/80 text-text-primary px-6 py-3 rounded-lg font-medium transition-colors"
          >
            Go Home
          </Link>

          <Link
            to={quizRoute}
            className="inline-block bg-brand-secondary hover:bg-brand-secondary/80 text-text-inverse px-6 py-3 rounded-lg font-medium transition-colors ml-4"
          >
            Start Quiz
          </Link>
        </div>
      </div>
    </div>
  );

  return <ErrorBoundary fallback={fallback}>{children}</ErrorBoundary>;
}

export default RouteErrorBoundary;
